import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-software-development',
  templateUrl: './software-development.component.html',
  styleUrls: ['./software-development.component.scss']
})
export class SoftwareDevelopmentComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'Software Development - Xipe Tech';
  contentDescription = 'XipeTech delivers high-quality software development services, creating innovative, scalable, and efficient solutions to meet your business needs. From custom applications to enterprise systems, we turn ideas into reality with cutting-edge technologies.';
  contentKeywords = 'software development, custom software, enterprise software, web application development, mobile app development, software solutions, IT services, XipeTech software, business software development, innovative technology solutions';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
